import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';

function resetTimesStoreCommandDefinition(
  defineCommand: any,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource
): any {
  return defineCommand('resetTimesStoreCommand', function resetTimesStoreCommand(deferred: ng.IDeferred<any>): any {
    _.remove(ngTimeOccurrenceDataSource.store, undefined);
    deferred.resolve();
  });
}

angular.module('ui-ng-calendar').factory('resetTimesStoreCommand', resetTimesStoreCommandDefinition);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/reset_times_store.ts